import { z } from 'zod';
import { BULK_LIMITS, BULK_OPERATION_NAMES } from '../domain/bulk.js';

/**
 * One action on many sites (ADR-0046). A risky one is confirmed by typing how
 * many sites it is for: the number is what a slip of the selection changes.
 */
export const createBulkRunSchema = z.object({
  operation: z.enum(BULK_OPERATION_NAMES),
  siteIds: z.array(z.string().uuid()).min(1).max(BULK_LIMITS.sites)
    .refine((ids) => new Set(ids).size === ids.length, 'Each site once'),
  confirmation: z.string().max(10).optional(),
  /** The version a `template_upgrade` brings the sites to (ADR-0047). */
  templateVersionId: z.string().uuid().optional(),
}).strict();
export type CreateBulkRunRequest = z.input<typeof createBulkRunSchema>;
